<template>
  <button-link size="small" type="success" :to="link">
    <slot>添加停车区</slot>
  </button-link>
</template>

<script>
import ButtonLink from '@c/ButtonLink'
import Mixin from '@c/LzTable/Mixin'

export default {
  name: 'RowAddParking',
  components: {
    ButtonLink,
  },
  mixins: [
    Mixin,
  ],
  data() {
    return {
      identify: undefined,
    }
  },
  computed: {
    link() {
      this.checkResourceName()
      // console.log(this.identify)
      return `/parking/${this.identify}`
    },
  },
  mounted() {
    this.setIdentify()
  },
}
</script>
